import type { Ref } from "vue";
import { useAnimationStep, type UseAnimationStepProps } from "./useAnimationStep";
import { watch } from "vue";

export type TweenProps = Omit<UseAnimationStepProps, 'initial'>; 

export const tween = (inputValue: Ref<number>, props: TweenProps = {}) => {
  const anim = useAnimationStep({ initial: inputValue.value, ...props})
  
  watch(inputValue, (next) => {
    anim.to(next);
  });
  
  return anim.current;
}
